import {
  DeliveryGroupListInput,
  ListDeliveryGroupListInputDocument,
  ListDeliveryGroupListInputQuery,
} from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 配達グループ一覧を取得する
 * @param deliveryGroupListInput 配達グループ情報
 * @returns 配達グループ情報
 */
export async function getDeliveryGroupList(
  deliveryGroupListInput: DeliveryGroupListInput
): Promise<
  | (
      | {
          __typename?: "DeliveryGroupListResponse" | undefined;
          customer_code: string;
          chain_code: string;
          group_code: string;
          name: string;
          DeliveryGroupShopList?:
            | {
                __typename?: "DeliveryGroupShopList" | undefined;
                shop_code: string;
                shop_name: string;
              }[]
            | null
            | undefined;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const listDeliveryGroup: ApolloQueryResult<ListDeliveryGroupListInputQuery> =
      await apolloClient.query<ListDeliveryGroupListInputQuery>({
        query: ListDeliveryGroupListInputDocument,
        variables: {
          input: deliveryGroupListInput,
        },
        fetchPolicy: "no-cache",
      });
    return listDeliveryGroup.data.listDeliveryGroup;
  } catch (err: unknown) {
    if (err instanceof Error) {
      err.message = "配達グループ一覧の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("配達グループ一覧の取得に失敗しました。（不明なエラー）");
    }
  }
}

/**
 * 配達グループ便一覧を取得する
 * @param customerCode
 * @param chainCode
 * @param groupCode
 */
/*
export async function getDeliveryGroup(
  deliveryGroupGetInput: DeliveryGroupGetInput
): Promise<
  | (
      | {
          __typename?: "DeliveryGroup" | undefined;
          delivery_id: string;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const result: ApolloQueryResult<GetDeliveryGroupQuery> =
      await apolloClient.query<
        GetDeliveryGroupQuery,
        GetDeliveryGroupQueryVariables
      >({
        query: GetDeliveryGroupDocument,
        variables: {
          input: deliveryGroupGetInput,
        },
      });

    let listDeliveryGroupId = [];

    if (
      !(
        result.data.getDeliveryGroup.response.assigned_id_list === undefined ||
        result.data.getDeliveryGroup.response.assigned_id_list === null
      )
    ) {
      listDeliveryGroupId =
        result.data.getDeliveryGroup.response.assigned_id_list;
    }

    return listDeliveryGroupId;
  } catch (err: any) {
    err.message = "配達グループ便一覧の取得に失敗しました。";
    throw err;
  }
}
*/
